import { axios } from '@/request-clients/axios';
import { criticalQueryRetry } from '@/request-clients/query-retry';
import { VideoCallProvider } from '@my-ipractice/types/types';
import { useQuery } from '@tanstack/react-query';

export const useGetVideoCallProvider = () => {
  return useQuery<{ provider: VideoCallProvider }>({
    queryFn: async () => {
      const url = `clients/video-call/provider`;
      const response = await axios.get(url);
      return response.data;
    },
    queryKey: ['video-call-provider'],
    ...criticalQueryRetry,
    meta: {
      errorMessage: 'Error fetching video call provider',
    },
  });
};
